export const enum USER_ACTIONS {
  // Module name
  MODULE_USER = "User",

  // Mutations
  RESET_USER = "resetUser",

  // Actions
  AUTH_USER = "authUser",
  FETCH_INFO_USER = "fetchInfoUser",
}
